<p-dialog *ngIf="exibirModalAlterarEmpresa" modal="true" header="Alternar Empresa" [(visible)]="exibirModalAlterarEmpresa" [width]="800" [closable]="false">
  <div style="min-height: 300px;">
  <p-fieldset  [legend]="'Alterar a empresa a ser vinculada ao perfil ativo:'"
    [style]="{ 'margin-top': '10px' , 'min-height': '150px'}">
    <div class="ui-g-12" style="z-index: 1000">

      <p-dropdown [options]="listaEntidades" [(ngModel)]="entidade" [filter]="true" optionLabel="nome"
        dataKey="id"></p-dropdown>
    </div>
    <div *ngIf="entidade.empresaTipo && entidade.empresaTipo.id == '1'">
      <p-message severity="info" text="Empresa privada do tipo OSC/OSCIP. É possível manifestar interesse em anúncios, com base no Decreto 12.785, de 19 de dezembro de 2025."></p-message>
    </div>
  </p-fieldset>
  </div>

  <p-footer>
    <div class="buttons text-right">
      <button type="button" pButton label="Cancelar" class="ui-button-secondary" (click)="onCancelar()"></button>
      <button type="button" pButton label="Limpar" class="ui-button-secondary" (click)="limparEmpresa()"></button>
      <button type="submit" pButton label="Confirmar" class="ui-button-success" (click)="onConfirmar()"
       ></button>
    </div>
  </p-footer>
</p-dialog>
<!-- [(ngModel)]="anuncioTipoTic"
               [ngModelOptions]="{standalone: true}" -->
